import React from 'react'
import {
    CheckCircle as CheckCircleIcon,
    Lock as LockIcon,
} from '@mui/icons-material';
import Styles from './InterviewSections.module.scss'

export const InterviewSections = ({ section, index, handleChangeSection }) => {

    return (
        <li key={index} onClick={() => handleChangeSection(section.id)} className={`${Styles.menuItem}
                                    ${section.flag === 'current' ? Styles.activeMenuItem : ''}
                                    ${section.flag === 'completed' ? Styles.completedMenuItem : ''}
                                    ${section.flag === 'pending' ? Styles.pendingMenuItem : ''}
                                    ${section.flag === 'cc' ? Styles.currentAndCompletedMenuItem : ''}`}>
            <div
                className={`${Styles.sectionHeader} 
                                                     ${section.flag === 'current' ? Styles.activeStep : ''} 
                                                     ${section.flag === 'completed' ? Styles.completedStep : ''} 
                                                     ${section.flag === 'cc' ? Styles.completedStep : ''}`}
            >
                <div className={Styles.sectionTitle}>
                    {section.flag === 'next' && <LockIcon className={Styles.lockIcon} />}
                    <span className={Styles.sectionName}>{section.name}</span>
                    {(section.flag === 'completed' || section.flag === 'cc') && <CheckCircleIcon className={Styles.checkIcon} />}
                </div>
            </div>
        </li>
    )
}
